<template>
  <b-card-group class="text-center m-4" deck >
    <b-card>
      <template v-slot:header>
        <h1>Handles</h1>
      </template>
      <div v-for="(item,key) in handles"
           v-if="item.value"
           class="m-2 text-left"
           :key="key">
        <b>{{$t('domain')[item.label]}}</b>
        <v-select v-if="item.value"
                  v-model="domain_config[key]"
                  :clearable="false"
                  @input="emit_config() , $forceUpdate()"
                  :options="handle_options">
        </v-select>
      </div>
      <b-link v-if="options"
              @click="handles_switch = !handles_switch">
        <p class="m-4">
          {{! handles_switch ?  "Optionen" : "weniger..."}}
        </p>
      </b-link>
      <b-button v-if="handles_switch && options"
                variant="primary"
                title="Speichert als Vorlage"
                @click="saveSettings()"
                class="col-12">
        Einstllungen global speichern
      </b-button>

    </b-card>
    <b-card >
      <template v-slot:header>
        <h1>Nameserver</h1>
      </template>
      <div v-for="(item,key) in nameserver">
        <div v-if="item && ['ns1','ns2'].includes(key)"
             class="m-2 text-left"
             :key="key">
          <b>{{$t('domain')[item.label]}}</b>
          <v-select v-if="item.value"
                    v-model="domain_config[key]"
                    :clearable="false"
                    @input="emit_config() , $forceUpdate()"
                    :options="nameserver_options">
          </v-select>
        </div>
        <div class="m-2 text-left"
             v-if="nameserver_switch && item && ['ns3','ns4','ns5'].includes(key)">
          <b>{{$t('domain')[item.label]}}</b>
          <v-select v-if="item.value"
                    v-model="domain_config[key]"
                    :clearable="false"
                    @input="emit_config() , $forceUpdate()"
                    :options="nameserver_options">
          </v-select>
        </div>
      </div>
      <b-link
              @click="nameserver_switch = !nameserver_switch">
        <p class="m-4">
          {{ !nameserver_switch ? "Optionen" : "weniger..."}}
        </p>
      </b-link>
      <b-button v-if="nameserver_switch && options"
                variant="primary"
                title="Speichert als Vorlage"
                @click="saveSettings()"
                class="col-12">
        Einstllungen global speichern
      </b-button>
    </b-card>
  </b-card-group>

</template>

<script>
  import {UserConfigDefaults} from "@/store/models/layout/user_config"
  import {DomainHandle} from "@/store/models/domain/domain_handle";
  import {DomainNameserver} from "@/store/models/domain/domain_nameserver";


  export default {
    name: "luma-order-ns-hd-settings-domain",
    props:{
        extern_config:Object,
        auto_emit:Boolean,
        options:Boolean
    },
    data:()=>({
      edit:false,
      optinalNameserver:false,
      domain_config:null,
      handles_switch:false,
      nameserver_switch:false,
      handle_list: null,
      nameserver_list: null
    }),
    methods:{
      saveSettings(){
        const s = UserConfigDefaults.save(this.domain_configuration)
      },
      emit_config(){
        console.log(this.domain_configuration)
        this.$emit('emit_config',this.domain_configuration)
      }
    },
    computed:{
      domain_configuration(){

        this.domain_config !== null   ? this.domain_config
                                      : this.domain_config = {}
                                      Object.keys(this.handles).map(el=>{this.domain_config[el]=this.handles[el].value})
                                      Object.keys(this.nameserver).map(el=>{this.domain_config[el]=this.nameserver[el].value})
          console.log('0')
          return this.domain_config
      },
      nameserver_options(){
        const x = DomainNameserver.all().map(el=>el.servername)
        console.log('1')
        return x
      },
      handle_options(){
        const y = DomainHandle.fetchall()
        const x = DomainHandle.all().map(el=>el.handle)
          console.log('2')
          return x
      },
      handles(){
        if (this.handle_list !== null) return this.handle_list
        const keys = UserConfigDefaults.handleKeys
        this.handle_list= {}
        const l = keys.map(el=> this.$userConfig[el] ?
            this.handle_list[el] = {
                      value : this.$userConfig[el],
                      label : el,
                      disabled : true
                    }
                  : this.handle_list[el] = {
                      value: 'undefined',
                      label:'undefined',
                      disabled : false
                    }
                  )
          console.log('3')
          return this.handle_list
      },
      nameserver(){
          if (this.nameserver_list !== null) return this.nameserver_list
          const keys = UserConfigDefaults.nameserverKeys
        this.nameserver_list={}
        const l = keys.map(el=> this.$userConfig[el] ?
            this.nameserver_list[el] = {
                    value : this.$userConfig[el],
                    label : el,
                    disabled : true
                  }
                  : this.nameserver_list[el] = {
                    value: ' ',
                    label:el,
                    disabled : false
                  }
                )
          console.log('4')
          return this.nameserver_list
      }
    },
    created() {
      if(this.auto_emit){
          this.emit_config()
      }
      if(this.extern_config){
          this.domain_config = Object.assign({},this.extern_config)
      }
        this.domain_configuration ? true : false
        UserConfigDefaults.getConfigs(this.$currentUser.$id)
        const y = DomainNameserver.fetch()
    }

  }
</script>

<style scoped>
  .costum-card{
    max-width: 600px;
    margin-bottom: 24px;
    margin-top: 24px;
    margin-right: auto;
    margin-left: auto;
  }
</style>



// WEBPACK FOOTER //
// src/components/domain/create_domain/luma-order-ns-hd-settings-domain.vue